$(document).on("click", "#drawer-toggle", function (e) {
      $('#menu-drawer').addClass('open');
      $('.custom_overlay').addClass('active');
      console.log("dd")
    });
$(document).on("click", "#drawer-close", function (e) {
      $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
    });

    // Optional: Close on clicking outside
$(document).on("click", function (e) {
      if (!$(e.target).closest('#menu-drawer, #drawer-toggle').length) {
        $('#menu-drawer').removeClass('open');
      $('.custom_overlay').removeClass('active');
      }
    });

// Open child menu
  $(document).on('click', '.drawer-menu-item.has-children > .parent-link', function(e) {
    e.preventDefault();
    $(this).siblings('.sub-menu').addClass('open');
  });

  // Go back to parent menu
  $(document).on('click', '.sub-menu .back-btn a', function(e) {
    e.preventDefault();
    $(this).closest('.sub-menu').removeClass('open');
  });



// Toggle cart slide-out drawer
function openCartDrawer() {
  $('#cart-drawer').addClass('open');
  $('.custom_overlay2').addClass('active');
  initCartOfferTimer();
}

$(document).on("click", "#cart-toggle", function (e) {
  e.preventDefault();
  e.stopPropagation();
  openCartDrawer();
});

$(document).on("click", "#cart-close,.cart_empty_button", function (e) {
  e.preventDefault();
  $('#cart-drawer').removeClass('open');
  $('.custom_overlay2').removeClass('active');
});

// Click overlay or outside to close
$(document).on('click', '.custom_overlay2', function () {
  $('#cart-drawer').removeClass('open');
  $('.custom_overlay2').removeClass('active');
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('#cart-drawer, #cart-toggle').length) {
    $('#cart-drawer').removeClass('open');
    $('.custom_overlay2').removeClass('active');
  }
});

// Close the cart drawer when the Postscript popup opens (teaser "GET 40% OFF" click).
// The widget lives in a cross-origin iframe (#ps__widget), so its clicks/DOM are
// invisible to us. But Postscript resizes the iframe from a small teaser pill
// (~171x81) to a large overlay when the popup opens — we watch for that.
(function () {
  var popupWasOpen = false;
  var checkQueued = false;

  function isPopupOpen() {
    var frame =
      document.getElementById('ps__widget') ||
      document.querySelector('iframe[data-testid="ps__widget"]');
    if (!frame) return false;
    var r = frame.getBoundingClientRect();
    return r.width > 300 && r.height > 300;
  }

  function check() {
    checkQueued = false;
    var open = isPopupOpen();
    if (open && !popupWasOpen) {
      $('#cart-drawer').removeClass('open');
      $('.custom_overlay2').removeClass('active');
    }
    popupWasOpen = open;
  }

  function queueCheck() {
    if (checkQueued) return;
    checkQueued = true;
    setTimeout(check, 100);
  }

  // Postscript toggles the iframe's inline style to resize it
  var observer = new MutationObserver(queueCheck);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });

  // Clicking into an iframe blurs the window — a reliable moment to re-check
  window.addEventListener('blur', function () {
    setTimeout(check, 250);
  });
})();

// Upsell purchase option radios
$(document).on('click', '[data-upsell-option]', function (e) {
  e.preventDefault();
  const $opt = $(this);
  const $card = $opt.closest('[data-upsell-card]');
  $card.find('[data-upsell-option]').removeClass('is-selected');
  $opt.addClass('is-selected');
  const $atc = $card.find('.recommended_product_button');
  $atc.attr('variant_id', $opt.attr('data-variant-id'));
  const plan = $opt.attr('data-selling-plan') || '';
  if (plan) {
    $atc.attr('selling_plan', plan);
  } else {
    $atc.removeAttr('selling_plan');
  }
  const price = $opt.attr('data-price');
  if (price) $card.find('[data-upsell-display-price]').text(price);

  const save = parseInt($opt.attr('data-save'), 10) || 0;
  const $saveBadge = $card.find('[data-upsell-save-badge]');
  if (save > 0) {
    $saveBadge.text('SAVE ' + save + '%').show();
  } else {
    $saveBadge.hide();
  }
});

// Cart offer countdown timer
let cartTimerInterval = null;
function initCartOfferTimer() {
  const $timer = $('[data-cart-timer]').first();
  if (!$timer.length) return;

  const minutes = parseInt($timer.attr('data-minutes'), 10) || 10;
  const totalMs = minutes * 60 * 1000;
  const storageKey = 'cart_offer_timer_end';
  let end = parseInt(sessionStorage.getItem(storageKey), 10);
  const now = Date.now();
  if (!end || end < now) {
    end = now + totalMs;
    sessionStorage.setItem(storageKey, String(end));
  }

  function tick() {
    const remaining = Math.max(0, end - Date.now());
    const secs = Math.floor(remaining / 1000);
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    const label = m + ':' + String(s).padStart(2, '0');
    $('[data-cart-timer-text]').text(label);
    const pct = Math.max(0, Math.min(100, (remaining / totalMs) * 100));
    $('[data-cart-timer-fill]').css('width', pct + '%');
    if (remaining <= 0 && cartTimerInterval) {
      clearInterval(cartTimerInterval);
      cartTimerInterval = null;
    }
  }

  tick();
  if (cartTimerInterval) clearInterval(cartTimerInterval);
  cartTimerInterval = setInterval(tick, 1000);
}

function clearCartDrawerLoading() {
  $('#cart_drawer_content').removeClass('loading_hk');
}

function refreshCartDrawer(options) {
  options = options || {};

  return $.ajax({
    url: window.location.pathname,
    type: 'GET',
    dataType: 'html',
    success: function (data) {
      const $newDrawer = $(data).find('#cart_drawer_content');
      const $newCartCount = $(data).find('.cart_count_js');
      const cartCount = parseInt($newCartCount.text().trim(), 10);
      $('#cart_drawer_content').replaceWith($newDrawer);

      if (cartCount > 0) {
        $('.cart_count_js').text(cartCount).show();
        $('#cart-drawer').removeClass('is_empty');
      } else {
        $('.cart_count_js').text('').hide();
        $('#cart-drawer').addClass('is_empty');
      }
      const $items = $('.cart_item_single');
      if ($items.length === 1 && $items.find('img.item_image[alt="Shipping Protection"]').length) {
        $items.find('.cart_item_single_right_remove').trigger('click');
      }
      initCartOfferTimer();
      if (options.open) openCartDrawer();
    }
  }).always(function () {
    clearCartDrawerLoading();
  });
}

// Shared API for add-to-cart forms across home, product and offer pages.
window.refreshAndOpenCartDrawer = function () {
  return refreshCartDrawer({ open: true });
};

 function updateCart(variantId, quantity, key, sellingPlan = null) {
    if (!key || !Number.isFinite(quantity) || quantity < 0) {
      clearCartDrawerLoading();
      return;
    }

    const payload = {
      id: key,
      quantity: quantity
    };

    if (sellingPlan) {
      payload.selling_plan = sellingPlan;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify(payload),
      dataType: 'json',
      contentType: 'application/json',
      success: function () {
        refreshCartDrawer();
      },
      error: function (xhr) {
        console.error('Cart update failed:', xhr);
        clearCartDrawerLoading();
      }
    });
  }

  // Switch line between subscription plan ↔ one-time (Neuro-style cart controls)
  function changeCartSellingPlan(lineKey, quantity, sellingPlanId, purchaseType) {
    if (!lineKey) {
      clearCartDrawerLoading();
      return $.Deferred().reject().promise();
    }

    const payload = {
      id: lineKey,
      quantity: quantity,
      selling_plan: sellingPlanId ? String(sellingPlanId) : '',
      properties: {
        'Purchase Type': purchaseType || (sellingPlanId ? 'Subscribe & Save' : 'One-time'),
        _purchase_type: sellingPlanId ? 'subscribe' : 'onetime',
      },
    };

    return $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify(payload),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function () {
        refreshCartDrawer();
      })
      .fail(function (xhr) {
        console.error('Selling plan change failed:', xhr?.responseText || xhr);
        clearCartDrawerLoading();
        alert('Could not update delivery option. Please try again.');
      });
  }

  // One-time line → Subscribe & Save
  $(document).on('click', '[data-cart-subscribe]', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $wrap = $btn.closest('.cart_plan_switcher');
    const key = $wrap.attr('data-line-key');
    const qty = parseInt($wrap.attr('data-quantity') || '1', 10) || 1;
    const planId = $btn.attr('data-selling-plan');
    if (!key || !planId) return;

    $('#cart_drawer_content').addClass('loading_hk');
    $btn.prop('disabled', true);
    changeCartSellingPlan(key, qty, planId, 'Subscribe & Save');
  });

  // Subscription line → change frequency or One-time only
  $(document).on('change', '[data-cart-plan-select]', function () {
    const $select = $(this);
    const $wrap = $select.closest('.cart_plan_switcher');
    const key = $wrap.attr('data-line-key');
    const qty = parseInt($wrap.attr('data-quantity') || '1', 10) || 1;
    const planId = $select.val() || '';
    const prev = $wrap.attr('data-current-plan') || '';

    if (!key) return;
    if (String(planId) === String(prev)) return;

    $('#cart_drawer_content').addClass('loading_hk');
    $select.prop('disabled', true);
    changeCartSellingPlan(
      key,
      qty,
      planId,
      planId ? 'Subscribe & Save' : 'One-time'
    );
  });



 

// Plus
$(document).on('click', '.quantity_plus', function (e) {
  e.preventDefault();
  $('div#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $real = $wrap.find('input[name="quantity_single"]');
  const $fake = $wrap.find('.fake_quantity_display');

  let realQty = parseInt($real.val(), 10) || 0;
  let fakeQty = parseInt($fake.val(), 10) || 0;

  realQty++;
  fakeQty++;

  $real.val(realQty);
  $fake.val(fakeQty);

  updateCart($real.attr('variant_id'), realQty, $real.attr('key'), $real.attr('selling_plan') || null);
});

// Minus
$(document).on('click', '.quantity_minus', function (e) {
  e.preventDefault();
  $('div#cart_drawer_content').addClass('loading_hk');
  const $wrap = $(this).closest('.cart_quantity_wrapper');
  const $real = $wrap.find('input[name="quantity_single"]');
  const $fake = $wrap.find('.fake_quantity_display');

  let realQty = parseInt($real.val(), 10) || 0;
  let fakeQty = parseInt($fake.val(), 10) || 0;

  if (realQty <= 0) {
    clearCartDrawerLoading();
    return;
  }

  realQty--;
  fakeQty--;

  $real.val(realQty);
  $fake.val(fakeQty);

  updateCart($real.attr('variant_id'), realQty, $real.attr('key'), $real.attr('selling_plan') || null);
});

// Remove (trigger all same-variant removes)
/*
$(document).on('click', '.cart_item_single_right_remove', function () {
  $('div#cart_drawer_content').addClass('loading_hk');

  const variantId = $(this).attr('variant_id');

  // trigger ALL remove buttons for this variant
  $(`.remove-variant-${variantId}`).each(function () {
    const itemKey = $(this).attr('key');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: JSON.stringify({ id: itemKey, quantity: 0 }),
      contentType: 'application/json',
      dataType: 'json',
      success: function () {
        refreshCartDrawer();
      }
    });
  });
});
*/
// Remove only THIS cart line (by key) — do not wipe every line with the same variant
// (one-time + subscribe share a variant id but must stay independent)
$(document).on('click', '.cart_item_single_right_remove', function () {
  const $btn = $(this);
  const $drawer = $('#cart_drawer_content').addClass('loading_hk');
  const itemKey = $btn.attr('key');

  if (!itemKey) {
    $drawer.removeClass('loading_hk');
    return;
  }

  $btn.prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    contentType: 'application/json; charset=UTF-8',
    dataType: 'json',
    data: JSON.stringify({ id: itemKey, quantity: 0 }),
  })
    .done(function () {
      if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
    })
    .fail(function (xhr) {
      console.error('Remove line failed:', xhr?.responseText || xhr);
      $drawer.removeClass('loading_hk');
    })
    .always(function () {
      $btn.prop('disabled', false);
    });
});










$(document).on("click", ".recommended_product_button", function(e) {
  e.preventDefault();
  var $el = $(this).addClass("loading_hk");
  var payload = {
    quantity: $el.attr("quantity") || 1,
    id: $el.attr("variant_id")
  };
  var plan = $el.attr("selling_plan");
  if (plan) payload.selling_plan = plan;

  $.post("/cart/add.js", payload, function() {
    $.get(window.location.pathname, function(res) {
      $("#cart_drawer_content").replaceWith($(res).find("#cart_drawer_content"));
      $("#cart-drawer").removeClass("is_empty").addClass("open");
      $(".custom_overlay2").addClass("active");
      initCartOfferTimer();
      $el.removeClass("loading_hk");
    });
  }, "json").fail(function () {
    $el.removeClass("loading_hk");
  });
});


function updateVh() {
  document.documentElement.style.setProperty('--real-vh', `${window.innerHeight}px`);
}
window.addEventListener('resize', updateVh);
window.addEventListener('load', updateVh);


$(document).on("click", "li.desktop_nav_menu.has-children > a.desktop_nav_parent", function (e) {
  e.preventDefault(); // prevent default link behavior if needed
  $(this).toggleClass('active');
  $(this).next().slideToggle(); // toggle the next sibling element (usually a submenu)
});

/*
$(document).on("click", "a.checkout_button", async function(e) {
  e.preventDefault();
$(this).addClass('loading_hk');
  const checkoutURL = await getCheckoutURL();
  window.location.href = checkoutURL;
});
*/